import { queryOptions } from '@tanstack/react-query';
import { VectorService } from '../service/VectorService';

const vectorQueries = {
  allNamespaces: () =>
    queryOptions({
      queryKey: ['namespaces'],
      queryFn: () => VectorService.listAll(),
    }),
};

export { vectorQueries };
